// extracted by mini-css-extract-plugin
export default {"main":"Main_main__2YT-U","title":"Main_title__FpdvM","content":"Main_content__IvKTJ"};